/**
 * 受注
 * 回収履歴
 */
import Vue from "vue";
import * as httpConst from "../../../../constants/httpConst";

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/orders/accepts/histories`;

const getDefaultState = () => {
  return {
  };
};

const order_history = {
  namespaced: true,
  state: getDefaultState(),
  getters: {},
  actions: {
    /**
     * 直近の回収履歴一覧の取得
     * @param dispatch
     * @param commit
     * @param state
     * @param conditions { Object }
     * @return {Promise<unknown>}
     */
    index( { dispatch, commit, state }, { conditions} ) {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: conditions }).then((data) => {
          let content = data.content;
          resolve(content);
        });
      });
    },
    /**
     * 直近の回収履歴の取得
     * @param commit
     * @param id
     * @return {Promise<unknown>}
     */
    show({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`;
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then((data) => {
          resolve(data.content);
        });
      });
    },
  },
};

export default order_history;
